document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gb-offers]').forEach(group => {
    const root = group.closest('.buy-buttons-block');
    const qty = root && root.querySelector('input[name="quantity"]');
    group.querySelectorAll('[data-gb-qty]').forEach(btn => btn.addEventListener('click', () => {
      group.querySelectorAll('[data-gb-qty]').forEach(x => { x.classList.remove('is-selected'); x.setAttribute('aria-pressed','false'); });
      btn.classList.add('is-selected'); btn.setAttribute('aria-pressed','true');
      if (qty) { qty.value = btn.dataset.gbQty; qty.dispatchEvent(new Event('change', {bubbles:true})); }
    }));
  });
  document.querySelectorAll('[data-gb-countdown]').forEach(el => {

  const duration = 53 * 60 * 1000; // 53 minutos
  const storageKey = 'geanbeni_countdown_start';

  const h = el.querySelector('[data-gb-hours]');
  const m = el.querySelector('[data-gb-minutes]');
  const s = el.querySelector('[data-gb-seconds]');

  let startTime = localStorage.getItem(storageKey);

  if (!startTime) {
    startTime = Date.now();
    localStorage.setItem(storageKey, startTime);
  } else {
    startTime = Number(startTime);
  }

  const tick = () => {
    const elapsed = Date.now() - startTime;
    let left = duration - elapsed;

    // Si llega a cero, vuelve a comenzar
    if (left <= 0) {
      startTime = Date.now();
      localStorage.setItem(storageKey, startTime);
      left = duration;
    }

    const totalSeconds = Math.floor(left / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    h.textContent = String(hours).padStart(2, '0');
    m.textContent = String(minutes).padStart(2, '0');
    s.textContent = String(seconds).padStart(2, '0');
  };

  tick();
  setInterval(tick, 1000);
});
});
// GEANBENI - Comprar ahora según oferta seleccionada
document.addEventListener('click', async function (event) {
  const buyButton = event.target.closest('[data-gb-buy-now]');
  if (!buyButton) return;

  event.preventDefault();

  const root = buyButton.closest('.buy-buttons-block');
  if (!root) return;

  const selectedOffer = root.querySelector('[data-gb-qty].is-selected');
  const quantity = selectedOffer ? parseInt(selectedOffer.dataset.gbQty, 10) : 1;

  const variantInput = root.querySelector('input[name="id"]');
  if (!variantInput || !variantInput.value) return;

  buyButton.disabled = true;

  try {
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantInput.value),
        quantity: quantity
      })
    });

    window.location.href = '/checkout';
  } catch (error) {
    console.error('GEANBENI checkout error:', error);
    buyButton.disabled = false;
  }
});